import styles from './LightTextRenderer.module.scss';
import { ReactElement } from 'react';

export function LightTextRenderer({ value }: { value: string }): ReactElement {
  return <span className={`${styles.defaultCell} ${styles.lightText}`}>{value}</span>;
}

export default LightTextRenderer;
